module.exports = __webpack_public_path__ + "static/media/crocodile(10).618d681e.PNG";